import type { AxiosResponse } from 'axios'
import { http } from './http'
import { ENDPOINTS } from './endpoints'
import type { ApiResponse } from './http/types'
import type { ThemeSchema } from '@/types/theme-workspace'
import { normalizeThemeSchema, type RawThemeSchema } from './theme-schema.adapter'

export const themeService = {
  schema: async (themeId: string): Promise<AxiosResponse<ApiResponse<ThemeSchema>>> => {
    const response = await http.get<ApiResponse<ThemeSchema | RawThemeSchema>>(ENDPOINTS.themes.schema(themeId))

    response.data = {
      ...response.data,
      data: normalizeThemeSchema(response.data.data),
    } as ApiResponse<ThemeSchema>

    return response as AxiosResponse<ApiResponse<ThemeSchema>>
  },
}
